import { h } from "preact";
import { Modal, Button, Typography } from "antd";

export const VlinkModal = ({
                               setIsModalOpen,
                               isModalOpen,
                               vlink,
                               setVlink,
                           }) => {
    const onTooltipClick = (value) => navigator.clipboard.writeText(value);

    return (
        <Modal
            visible={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false);
                setVlink("");
            }}
            footer={null}
            width={700}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#3C8DFC",
                    flexDirection: "column",
                }}
            >
                <Typography.Text>
                    <h2>Great!</h2>
                </Typography.Text>
                <Typography.Text>
                    <p>Your flow was successfully created!</p>
                </Typography.Text>
                <Typography.Text>
                    <p>Copy the link below to proceed.</p>
                </Typography.Text>
                <Button style={{ marginLeft: "10px" }}>
                    <Typography.Text
                        onClick={onTooltipClick(vlink)}
                        copyable
                        className="settings-api-tab-key"
                    >
                        {vlink}
                    </Typography.Text>
                </Button>
            </div>
        </Modal>
    );
};
